module.exports = __webpack_public_path__ + "static/media/rszaloki.65e444f8.jpg";